import { $closest, $delegate, $find, $on, $qs } from 'fxdom/es';
import { curry, go } from 'fxjs/es';
import { MuiF } from '../../../Mui/F/Function/module/MuiF.js';
import { MShopUtilF } from '../../../MShop/Util/F/Function/module/MShopUtilF.js';

export const paginationEvent = curry((callback, el) => {
  const is_mobile = MShopUtilF.isMobile();
  $on('popstate', async (e) => {
    const { paginationData } = e.state;
    if (!paginationData) return;
    if (paginationData.current_page === getPaginationState().current_page) return;
    await callback(paginationData);
    const currentTop = $qs('.labs__content-container')?.offsetTop;
    if (currentTop && is_mobile) {
      window.scrollTo({
        top: currentTop,
        behavior: 'smooth',
      });
    }
  })(window);

  return go(
    el,
    $delegate('click', `.maple-labs-pagination__item`, async (e) => {
      const cur_pagination_state = go(
        e.currentTarget,
        $closest('.maple-labs-pagination'),
        getPaginationState,
      );
      const new_pagination_state = go(e.currentTarget, getPaginationState);

      if (cur_pagination_state.current_page === new_pagination_state.current_page) return;

      initPageLocationSearch(cur_pagination_state);
      updatePageLocationSearch(new_pagination_state);

      await callback(new_pagination_state);

      const currentTop = $qs('.labs__content-container')?.offsetTop;
      if (currentTop) {
        window.scrollTo({
          top: currentTop,
          behavior: is_mobile ? 'smooth' : 'instant',
        });
      }
    }),
  );
});

const updatePageLocationSearch = (paginationData) => {
  const search_params = new URLSearchParams(location.search);
  search_params.set('page', paginationData.current_page);
  MuiF.extendHistoryState({ paginationData }, null, `${location.pathname}?${search_params.toString()}`);
};

const initPageLocationSearch = (paginationData) => {
  if (history.state && history.state.paginationData) return;
  const search_params = new URLSearchParams(location.search);
  MuiF.extendHistoryState({ paginationData }, null, `${location.pathname}?${search_params.toString()}`, true);
};

export const getPaginationState = ($page_el = $find('.maple-labs-pagination', document.body)) => {
  if (!$page_el) return null;
  const { page = 0, offset = 0, limit = 0, total = 0, length = 0 } = $page_el.dataset;
  return {
    offset: safeParseInt(offset),
    limit: safeParseInt(limit),
    current_page: safeParseInt(page) || Math.floor(safeParseInt(offset) / safeParseInt(limit)) + 1,
    total_page: safeParseInt(total),
    page_length: safeParseInt(length),
  };
};

const safeParseInt = (val) => {
  const parsed = parseInt(val);
  return isNaN(parsed) ? 0 : parsed;
};

export const getCurrentPage = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const page = urlParams.get('page') || 1;
  return safeParseInt(page);
};
